import { AlignLeft } from 'lucide-react'

export function ScopeBadge({ label }: { label: string }) {
  return (
    <div className="inline-flex items-center gap-1.5 rounded-full bg-scope-soft px-2.5 py-1 text-xs font-semibold text-scope">
      <AlignLeft className="h-3.5 w-3.5" />
      {label}
    </div>
  )
}
